import { useQuery, useMutation } from '@tanstack/react-query';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchAllPatient = async () => {
  const response = await fetch(`${apiUrl}/api/table_paciente`);
  if (!response.ok) {
    throw new Error('Error fetching blogs');
  }
  return response.json();
};

export const fetchPatientById = async numero_identidad => {
  const response = await fetch(`${apiUrl}/api/get_paciente`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ numero_identidad }),
  });

  if (!response.ok) {
    throw new Error('Error fetching patient by DNI');
  }

  return response.json();
};

export const createUpdatePatient = async data => {
  const response = await fetch(`${apiUrl}/api/paciente`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Error creating patient');
  }

  return response.json();
};
